// extracted by mini-css-extract-plugin
export default {"content":"apps_content__MvVQZ"};